import React, { useMemo } from 'react';
import type { ProgramLearningBatchGenerateTarget } from '../../utils/programLearningBatchGenerate';

type TrackLearningBatchGenerateConfirmModalProps = {
  targets: ProgramLearningBatchGenerateTarget[];
  busy?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

function uniquePublisherRows(targets: ProgramLearningBatchGenerateTarget[]) {
  const seen = new Set<string>();
  const rows: { trackName: string; publisher: string }[] = [];
  targets.forEach((target) => {
    const cardName = target.trackName.trim();
    const trackName = (target.templateName || target.trackName).trim();
    const publisher = target.publisher.trim();
    const key = cardName || `${trackName}\0${publisher}`;
    if (!trackName || !publisher || seen.has(key)) return;
    seen.add(key);
    rows.push({ trackName, publisher });
  });
  return rows;
}

const TrackLearningBatchGenerateConfirmModal: React.FC<
  TrackLearningBatchGenerateConfirmModalProps
> = ({ targets, busy = false, onCancel, onConfirm }) => {
  const rows = useMemo(() => uniquePublisherRows(targets), [targets]);

  return (
    <div
      className="cp-modal-backdrop"
      onClick={() => {
        if (!busy) onCancel();
      }}
    >
      <div
        className="cp-modal cp-track-learning-batch-confirm-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="cp-track-learning-batch-confirm-title"
      >
        <h3 id="cp-track-learning-batch-confirm-title">학습내용 일괄 생성</h3>
        <div className="cp-modal-body">
          <ul className="cp-track-learning-batch-confirm-list">
            {rows.map((row) => (
              <li
                key={`${row.trackName}:${row.publisher}`}
                className="cp-track-learning-batch-confirm-item"
              >
                <span className="cp-track-learning-batch-confirm-track">{row.trackName}</span>
                <span className="cp-track-learning-batch-confirm-sep"> : </span>
                <span className="cp-track-learning-batch-confirm-publisher">{row.publisher}</span>
              </li>
            ))}
          </ul>
          <p className="page-desc cp-track-learning-batch-confirm-question">
            위와 같은 설정으로 각 출판사의 학습내용을 가져오겠습니까?
          </p>
        </div>
        <div className="cp-modal-footer">
          <button type="button" className="cp-btn-secondary" onClick={onCancel} disabled={busy}>
            취소
          </button>
          <button type="button" className="cp-btn-primary" onClick={onConfirm} disabled={busy}>
            {busy ? '가져오는 중...' : '확인'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrackLearningBatchGenerateConfirmModal;
